import React from 'react';
import * as R from 'ramda';
import {FormGroup, Label, Input} from 'reactstrap';

import {useFieldState, ErrorTooltip} from '@/Form/index';
import MaybeInputGrouped from '@/Form/MaybeInputGrouped';
import MaskedInput, {unmask} from '@/Form/MaskedInput';

import {useTranslation} from 'react-i18next';

import '@/Form/text.css';

const maskState = (mask, fieldState) => {
  const {value, onChange, ...restState} = fieldState;

  const handler = R.compose(
    ([name, rawValue]) => onChange({target: {name, value: rawValue}}),
    R.adjust(1, unmask(mask)),
    R.props(['name', 'value']),
    R.prop('target')
  );

  return {...restState, defaultValue: value, onChange: handler};
};

const Text = ({id, name, label, addons, mask, ...rest}) => {
  const fieldState = useFieldState({id, name});
  const {id: target, errors} = fieldState;

  const {t: tr} = useTranslation('common');

  const handleRequiredMessage = e => {
    if (e.target.value === '') {
      e.target.setCustomValidity(tr('cannot_be_blank'));
    } else {
      e.target.setCustomValidity();
    }
  };
  const clearRequiredMessage = e => e.target.setCustomValidity('');

  return (
    <FormGroup>
      {label ? <Label htmlFor={target}>{label}</Label> : <></>}
      <MaybeInputGrouped addons={addons}>
        {mask ? (
          <MaskedInput mask={mask} {...maskState(mask, fieldState)} {...rest} />
        ) : (
          <Input
            onInput={clearRequiredMessage}
            onInvalid={handleRequiredMessage}
            {...fieldState}
            {...rest}
          />
        )}
      </MaybeInputGrouped>
      <ErrorTooltip errors={errors} target={target} />
    </FormGroup>
  );
};

export default Text;
